import { render } from "./PatientAuthorizedContactsForm.vue?vue&type=template&id=6db0c035&ts=true"
import script from "./PatientAuthorizedContactsForm.ts?vue&type=script&lang=ts&external"
export * from "./PatientAuthorizedContactsForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__